import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './styles.scss';
import { Button } from '@material-ui/core';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16,
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 300,
  height: 100,
  padding: 4,
  boxSizing: 'border-box',
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%',
};

const defaultImg = {
  display: 'block',
  width: '100px',
  height: '100px',
};

export default function Previews({ getFile, title, defaultFile }) {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    // accept: {
    //   "image/*": [],
    // },
    multiple: false,

    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles?.map((file) =>
          Object.assign(file, {
            preview:
              file.type.split('/')[0] === 'image'
                ? URL.createObjectURL(file)
                : URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files?.map((file, i) => (
    <div key={i}>
      <span
        className="position-absolute cursor-pointer"
        onClick={(e) => {
          setFiles([]);
          e.stopPropagation();
        }}
      >
        <CancelOutlinedIcon color="error" />
      </span>
      <div style={thumb} key={file.name}>
        <div style={thumbInner}>
          {file.type.split('/')[0] === 'image' ? (
            <img
              src={file.preview}
              style={img}
              // Revoke data uri after image is loaded
              onLoad={() => {
                URL.revokeObjectURL(file.preview);
              }}
            />
          ) : file.name.split('.').pop() === 'pdf' ? (
            <img src="/files/img/pdf.jpeg" />
          ) : file.name.split('.').pop() === 'xlsx' ? (
            <img src="/files/img/xlsx.png" />
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    getFile(files[0]);
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <section
      className="d-flex justify-content-center align-items-center"
      style={{ flexDirection: 'row-reverse' }}
    >
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <div className="d-flex justify-content-center align-items-center">
          {files.length === 0 && (
            <div className="d-flex justify-content-center align-items-center">
              <span className="ms-3">
                {!defaultFile ? (
                  <img src="/files/img/folders.png" />
                ) : (
                  <img style={defaultImg} src={defaultFile} />
                )}
              </span>
              <div className={'ms-4 ' + styles.uploadDocument}>
                <div className="mb-2">
                  {title || 'Please upload your document.'}
                </div>
                <div>
                  <Button variant="outlined" appearance="default">
                    انتخاب کنید
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
        {files.length > 0 && <aside style={thumbsContainer}>{thumbs}</aside>}
      </div>
    </section>
  );
}

<Previews />;
